import React, { useEffect } from 'react'
import styled from "styled-components"
import bridge from '@/config/JSbridge'
import { bg_color1 } from '@/styles/theme'
const HeaderContainer =styled.div`
  .container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    font-size: 17px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    line-height: 44px;
    z-index: 999;
    background-color: ${props=> props.bg_color? props.bg_color: bg_color1}
  }
`
const Left = styled.div`
  /* width: 80px; */
  font-size: 15px;
  padding: 0 16px;
`
const Center = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;

`
const Right = styled.div`
  /* width: 80px; */
  font-size: 15px;
  padding: 0 16px;
  img {
    width: 80px;
  }
  .share-img {
    width: 20px;
    width: 20px;
    vertical-align: middle;
  }
  .title_right {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
       width: 20px;
       margin-right: 5px;
    }
  }
`
export default ({left="", title="", right='' , bg_color="", leftClick, rightClick, hideNaviBar, className }) =>{
  const back = () => {
    bridge.callHandler('nativeEvent', {event: 'close', params: {
      isDelete: false
    }}, () => {})
  }

  useEffect(() => {
    if (hideNaviBar) {
      bridge.callHandler(
        'nativeEvent',
        {
          event: 'nativeControl',
          params: {
            navigation: {
              visibility: false
            },
            container: {},
            bottomToolbar: {
              visibility: false
            }
          }
        },
        () => {}
      );
    }
  }, [])

  return (
    <HeaderContainer bg_color={bg_color} className={className}>
      <div className={'container'} >
        <Left onClick={()=> leftClick ? leftClick() : back()}>{
          left || <i className="iconfont">&#xe653;</i>
        }</Left>
        <Center>{title}</Center>
        <Right onClick={()=> rightClick && rightClick()}>{right}</Right>
      </div>
    </HeaderContainer>
  )
}


// WEBPACK FOOTER //
// ./src/components/Header/index.js